import React from 'react';
import {useDropzone} from 'react-dropzone';

import {useSelector} from '../../state/hooks';
import * as PanelTypes from '../../state/views/panel/types';
import {useUploadMarkdownImage} from '../../util/images';
import type {PanelProps} from '../../util/panelProps';
import {InlineMarkdownEditor} from '../elements/InlineMarkdownEditor';
import {MarkdownConfig} from './common';

// We assume MarkdownPanel will never be mounted by AutoPanel as we
// assume props.panelRef is present.  PanelCompRedux always passes it.

const DEFAULT_MARKDOWN_BLOCK_BODY = 'Add markdown, images, and $\\LaTeX$';

type MarkdownPanelProps = PanelProps<MarkdownConfig> & {
  panelRef?: PanelTypes.Ref;
};

const MarkdownPanel: React.FC<MarkdownPanelProps> = props => {
  const [cursorIdx, setCursorIdx] = React.useState<number>();
  const view = useSelector(state =>
    props.panelRef == null ? null : state.views.views[props.panelRef.viewID]
  );
  const {uploadImages, uploadState, setUploadState} = useUploadMarkdownImage(
    view?.id || null
  );

  const {getRootProps, getInputProps, open} = useDropzone({
    onDrop: uploadImages,
    disabled: view == null,
    accept: ['image/*'],
    noDragEventsBubbling: true,
  });

  return (
    <div
      style={{height: '100%', outline: 'none'}}
      {...getRootProps({onClick: e => e.stopPropagation()})}>
      <InlineMarkdownEditor
        className="panel__inline-markdown"
        readOnly={props.readOnly ? props.readOnly : false}
        saveText={false}
        key="report-page"
        placeholder={DEFAULT_MARKDOWN_BLOCK_BODY}
        serverText={props.config.value}
        onBlur={text =>
          props.updateConfig({
            ...props.config,
            value: text,
          })
        }
        onChange={text => {
          setUploadState(undefined);
          props.updateConfig({
            ...props.config,
            value: text,
          });
        }}
        onPaste={uploadImages}
        onSelect={setCursorIdx}
        onHelpSelect={open}
        cursorIdx={cursorIdx}
        uploadState={uploadState}
        enableMarkdown
        autosave
        minRows={5}
        onContentHeightChange={props.onContentHeightChange}
      />
      <input {...getInputProps()} />
    </div>
  );
};

export default MarkdownPanel;
